import { render, staticRenderFns } from "./alarmBridgeBosch.vue?vue&type=template&id=6d00a010&scoped=true"
import script from "./alarmBridgeBosch.vue?vue&type=script&lang=js"
export * from "./alarmBridgeBosch.vue?vue&type=script&lang=js"
import style0 from "./alarmBridgeBosch.vue?vue&type=style&index=0&id=6d00a010&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d00a010",
  null
  
)

export default component.exports